import React from 'react'
import {normalTextStyle} from '../utils/styles'

function OtherTerminals({userProfile}) {

  if (userProfile?.forCosco) {
    return null
  }
  return <>
    <span style={{...normalTextStyle, marginTop: 20}}>For rail destinations, please make payment directly to the provider or their preferred online platform.</span>
    <span style={normalTextStyle}>
              For other terminals and depots, please reach out to your local <a
        href="https://www.oocl.com/usa/eng/localinformation/localcontacts/Pages/default.aspx?site=usa&lang=eng"
        target="_blank" rel="noreferrer">contact</a>.</span>
  </>
}

export default OtherTerminals
